<template>
    <div class="gctn">
        <div @click="menuClick(item)" class="gitem focus-s" v-for="item in menus" :key="item" :class="{ 'gsel': selectKey == item.key }">{{ item.name
            }}</div>
    </div>
</template>

<script>
export default {
    name: 'RoundGroupMenu',
    props: {
        menus: Array,
        selectKey: {
            type: String,
            default: ""
        }
    },
    methods:{
        ///菜单点击
        menuClick:function(item){
            this.$emit("menuClick",item)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.gctn {
    display: inline-flex;
    background: var(--ek-round-group-bgColor);
    border-radius: 20px;
    font-size: 14px;
    color: var(--ek-text-color2);
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 3px;
    padding-bottom: 3px;
}

.gitem {
    border-radius: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 3px;
    padding-bottom: 3px;
}

.gsel {
    background-color: var(--ek-mainbody-bgcolor);
    color: var(--ek-text-color1);
}
</style>
